<template>
	<div class="dashboard-wrap">
		<div class="dashboard">
			<div class="flex justify-between mb-5 items-center">
				<span class="font-bold">变更记录<span class="color1"> 仅展示最近3天的变更记录</span></span>
				<a-button @click="$router.go(-1)" type="primary">返回工作台</a-button>
			</div>
			<a-table rowKey="id" tableLayout="fixed" :scroll="{x: 1950}" bordered :columns="columns" :data-source="list" :pagination="pagination"></a-table>
			<a-space class="flex mt-5 justify-end">
				<a-button type="primary" @click="handleTableChange(parseFloat(page) - 1)" :disabled="previousPage">上一页</a-button>
				<a-input addon-after="页" @change="onChange" style="width: 120px" @pressEnter="pressEnter" type="number" v-model:value="page" />
				<a-button type="primary" :disabled="list.length < 10 ? true : false" @click="handleTableChange(parseFloat(page) + 1)">下一页</a-button>
			</a-space>
		</div>
		<a-modal
			:visible="previewVisible"
			:footer="null"
			@cancel="
				previewVisible = false
				previewImage = []
				previewIndex = 0
			">
			<!-- <img alt="example" style="width: 100%; margin-top: 20px" :src="previewImage" /> -->
			<div v-if="previewImage && previewImage.length">
				<img alt="example" style="width: 100%; margin-top: 20px" :src="previewImage[previewIndex]" />
				<div class="flex justify-between items-center mt-10" v-if="previewImage.length > 1">
					<a-button size="small" @click="previewIndex = (previewIndex - 1 + previewImage.length) % previewImage.length">上一张</a-button>
					<span>{{ previewIndex + 1 }} / {{ previewImage.length }}</span>
					<a-button size="small" @click="previewIndex = (previewIndex + 1) % previewImage.length">下一张</a-button>
				</div>
			</div>
		</a-modal>
	</div>
</template>

<script>
import {getChangeLog} from '@/api/dashboard/changeLog'
import {mapState} from 'vuex'
export default {
	name: 'ChangeLog',
	data() {
		return {
			list: [],
			columns: [
				{
					title: '变更类型',
					dataIndex: 'action_type',
					align: 'center',
					width: 100,
					customRender: (text, record) => {
						const action_type = {
							1: '创建订单',
							2: '短信发送',
							3: '短信送达',
							4: '销售转发邀请函被查看',
							5: '顾客转发邀请函被查看',
							6: '修改订单',
							7: '转台订单',
							8: '订单客已到',
							9: '取消订单'
						}
						return (
							<a-badge count={record.read ? '新' : ''} offset={[-68, -8]}>
								<div class={record.color}>{action_type[text] || '其它'}</div>
							</a-badge>
						)
					}
				},
				{
					title: '预订日期',
					dataIndex: 'order_date',
					align: 'center',
					width: 150,
					customRender: (text, record) => {
						return <div class={record.color}>{text || ''}</div>
					}
				},
				{
					title: '餐段',
					dataIndex: 'order_type',
					align: 'center',
					width: 150,
					customRender: (text, record) => {
						const name = this.initOrderType(record)
						return <div class={record.color}>{name || ''}</div>
					}
				},
				{
					title: '餐位名',
					dataIndex: 'with_room.title',
					align: 'center',
					width: 150,
					customRender: (text, record) => {
						return <div class={record.color}>{text || ''}</div>
					}
				},
				{
					title: '修改内容',
					dataIndex: 'msg',
					align: 'center',
					width: 300,
					customRender: (text, record) => {
						return <div class={record.color}>{text || ''}</div>
					}
				},
				{
					title: '预订人',
					dataIndex: 'name',
					align: 'center',
					width: 120,
					customRender: (text, record) => {
						return (
							<div class={record.color}>
								{text || ''}
								{record.sex === 1 ? '先生' : record.sex === 2 ? '女士' : ''}
							</div>
						)
					}
				},
				{
					title: '电话',
					dataIndex: 'phone',
					align: 'center',
					width: 150,
					customRender: (text, record) => {
						// 占座不显示电话
						if (record.hold_seat == 1) text = ''
						return <div class={record.color}>{text || ''}</div>
					}
				},
				{
					title: '人数',
					dataIndex: 'number',
					align: 'center',
					width: 100,
					customRender: (text, record) => {
						let unit = record.hold_seat == 1 ? '人' : record.unit
						return <div class={record.color}>{(text ? text : '') + unit || ''}</div>
					}
				},
				{
					title: '销售',
					width: 100,
					dataIndex: 'with_sale.nickname',
					align: 'center',
					customRender: (text, record) => {
						return <div class={record.color}>{text || ''}</div>
					}
				},
				{
					title: '备注',
					dataIndex: 'remark',
					align: 'center',
					width: 300,
					customRender: (text, record) => {
						let remarkText = ''
						let remarkImage = []
						let parsed = text ? JSON.parse(text) : null
						if (parsed) {
							remarkText = parsed?.text || ''
							let image = parsed?.image || []
							if (typeof image === 'string') {
								remarkImage.push(image)
							} else if (Array.isArray(image)) {
								remarkImage = [...image]
							}
						}
						return (
							<div class={record.color}>
								<div>{remarkText || ''}</div>
								{remarkImage && remarkImage.length > 0 ? (
									<a-button type="primary" size="small" onClick={() => this.onViewImage(remarkImage)}>
										备注图片
									</a-button>
								) : null}
							</div>
						)
					}
				},
				{
					title: '最后操作人',
					dataIndex: 'with_last_user.nickname',
					align: 'center',
					width: 150,
					customRender: (text, record) => {
						return <div class={record.color}>{text || ''}</div>
					}
				},
				{
					title: '最后操作时间',
					dataIndex: 'update_time',
					align: 'center',
					width: 200,
					customRender: (text, record) => {
						return <div class={record.color}>{text || ''}</div>
					}
				}
			],
			previewVisible: false,
			previewImage: [],
			previewIndex: 0,
			page: 1,
			pagination: false,
			previousPage: true
		}
	},
	async mounted() {
		this.page = 1
		this.getListData(this.page)
	},
	computed: {
		...mapState('user', {info: 'info'})
	},
	methods: {
		initOrderType(data) {
			const list = this.info?.shop?.to_sms_config?.sms_config?.meal_segment || []
			let name = list[data.order_type] ? list[data.order_type].name : ''
			if (name && this.info?.shop?.to_sms_config?.sms_config?.holiday_twice_meal_time && data.order_round > 1) {
				name += '(二轮)'
			}
			return name
		},
		//获取变更记录列表
		getListData(page) {
			this.$store.dispatch('loading/startContentLoading')
			getChangeLog({
				page
			}).then(res => {
				if (res.code === 0) {
					const noticeList = this.$route.query.orderNoticeList || []
					this.list = res.data.map(item => {
						return {
							...item,
							color: item.action_type && item.action_type == 9 ? 'color1' : '',
							read: noticeList.includes(item.id)
						}
					})
					this.page = page
				}
				this.$store.dispatch('loading/endContentLoading')
			})
		},
		onChange() {
			if (this.page < 1) this.page = 1
			this.previousPage = this.page == 1 ? true : false
		},
		// 回车事件
		pressEnter() {
			this.previousPage = this.page == 1 ? true : false
			this.getListData(this.page)
		},
		//分页
		handleTableChange(page) {
			this.previousPage = page == 1 ? true : false
			this.getListData(page)
		},
		//查看备注图片
		onViewImage(image) {
			this.previewImage = image
			this.previewVisible = true
		}
	}
}
</script>

<style scoped lang="less">
.dashboard-wrap {
	background-color: #f0f2f5;
	padding: 24px;
	box-sizing: border-box;
}

.dashboard {
	width: 100%;
	min-height: calc(100vh - 114px);
	background-color: #fff;
	border-radius: 4px;
	padding: 25px 22px;
	.feedback {
		margin-right: 15px;
	}
}

.top-bar {
	margin-bottom: 30px;
}

.color1 {
	color: #e63e30;
}
</style>
